import {Detail} from '@forecast-it/design-system';
import Moment from 'moment';
import React from 'react';
import {FormattedRelativeTime} from 'react-intl';
import {getTimeDifferenceAndUnit} from '../../../../util/TimeDifferenceUtil';

export interface RunTimestampProps {
	ranAt: string;
	'data-cy'?: string;
}

// A run's time, formatted the way the modal's own comment list formats every other timestamp on
// this surface (comment_section_comment.js): relative ("10 minutes ago") for anything under a
// month old, an absolute date once it is a month or more old. Built in UTC, like that component,
// so the same run reads identically in every timezone a test or a person could be sitting in.
export const RunTimestamp = (props: RunTimestampProps): JSX.Element => {
	const ranAtMoment = Moment.utc(props.ranAt);
	const {value, unit} = getTimeDifferenceAndUnit(ranAtMoment.toDate());
	return (
		<Detail color="medium" data-cy={props['data-cy']}>
			{unit === 'month' || unit === 'year' ? (
				ranAtMoment.format('LL')
			) : (
				<FormattedRelativeTime numeric="auto" value={unit === 'second' && value > -10 ? 0 : value} unit={unit} />
			)}
		</Detail>
	);
};
